<template>
  <section v-if="!channelsInit || (channelsInit && groupChannels.length)">
    <h5 :style="{ color: visualSettings.sidebarHeadingLabelColor }">{{visualSettings.groupChannelLabel}}</h5>
  
    <Notification 
      v-if="!(groupChannels || []).length"
      message="Loading Channels..."
      :icon="['fas', 'spinner']" 
      type="info"
    />

    <ChannelRow
      v-for="channel in groupChannels" :key="channel.id"
      :channel-id="channel.id"
      :name="channel.name"
      :image="channel.avatar"
      :enabled="true"
      :active="true"
      :notification-count="channel.notificationCount"
    />
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

  import Notification from '@/components/Notification';
import ChannelRow from '@/components/ChannelRow';

export default {
  name: 'Groups',
  components: {
    Notification,
    ChannelRow
  },
  computed: {
    ...mapGetters([
      'groupChannels',
      'visualSettings'
    ]),
    ...mapState([
      'channelsInit',
      'channelGroup',
      'channelGroupConnected',
      'channelGroupLoaded'
    ])
  }
}
</script>

<style scoped lang="scss">
section {
  margin: 0 0 20px;
}

h5 {
  margin: 0 0 6px;
  font-size: 13.6px;
  line-height: 1.1;
  color: rgba(47,49,56,0.6);
}
</style>
